import { render, staticRenderFns } from "./StatisticsDetails.vue?vue&type=template&id=c2e4c294&"
import script from "./StatisticsDetails.vue?vue&type=script&lang=js&"
export * from "./StatisticsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports